import styled from 'styled-components';

export const Container = styled.div`
  width: 700px;
  margin: 0 auto;
  @media (max-width: 991px) {
    width: auto;
  }
`;
export const Title = styled.h1`
  font-weight: 700;
  font-size: 30px;
  line-height: 36px;
  letter-spacing: 0px;
  margin: 25px 0;
  text-align: center;
`;
export const MainInfoContent = styled.div`
  background: #ffffffcc;
  border-top: 1px solid #e2e8f0;
  border-radius: 24px;
  box-shadow: 0px 8px 10px -6px #0000001a;
  box-shadow: 0px 20px 25px -5px #0000001a;
  padding: 33px;
  @media (max-width: 767px) {
    padding: 16px;
  }
`;
export const InputWrapper = styled.div`
  flex: ${(props) => props.flex || 1};
  position: relative;
  > div {
    min-height: auto;
    label {
      display: none;
    }
  }

  .react-tel-input input,
  .flag-dropdown {
    height: 60px;
    padding: 20px;
    border-radius: 14px;
    border: 2px solid #e2e8f0;
    background: #f8fafc;
    box-shadow:
      0px 1px 2px -1px #0000001a,
      0px 1px 3px 0px #0000001a;
    font-size: 16px;
    color: #212529;
    outline: none;
    transition: all 0.2s;
    border-left: 1px solid #e2e8f0;

    &::placeholder {
      color: #90a1b9;
    }
  }
  .react-tel-input {
    gap: 0;
  }
  &.phone-select {
    input {
      border-top-left-radius: 0 !important;
      border-bottom-left-radius: 0 !important;
      &:hover {
        border-left-color: #e2e8f0 !important;
      }
    }
  }
  .flag-dropdown {
    border-radius: 14px !important;
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right: none;
    padding: 0;
    width: 75px;
    .arrow {
      border-top: 4px solid #90a1b9;
    }
    .arrow.up {
      border-bottom: 4px solid #90a1b9;
      margin-top: -5px;
    }
    .selected-flag {
      width: 100%;
      padding: 0 0 0 16px;
    }
  }
  .css-17hzp7b-control,
  .css-mkw8ed-control {
    height: 60px;
    border-radius: 14px;
    border: 2px solid #e2e8f0;
    background: #f8fafc;
    box-shadow: 0px 1px 2px -1px #0000001a;
    box-shadow: 0px 1px 3px 0px #0000001a;
    font-size: 16px;
    color: #212529;
    outline: none;
    transition: all 0.2s;
  }
`;

export const Label = styled.div`
  font-weight: 600;
  font-size: 13px;
  color: #212529;
  margin-bottom: 3px;
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    font-weight: 500;
    font-size: 16px;
    color: #e45270;
  }
`;
export const InputGroup = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  margin-top: 20px;
  justify-content: flex-start;
  &.margin-none {
    margin-top: 0;
  }
  @media (max-width: 991px) {
    flex-direction: column;
  }
  .name-input input {
    height: 60px;
    padding: 20px;
    border-radius: 14px;
    border: 2px solid #e2e8f0;
    background: #f8fafc;
    box-shadow: 0px 1px 2px -1px #0000001a;
    box-shadow: 0px 1px 3px 0px #0000001a;
    font-size: 16px;
    color: #212529;
    outline: none;
    transition: all 0.2s;

    &::placeholder {
      color: #90a1b9;
    }
    &:hover {
      border-color: #15c7a7;
      box-shadow: 0px 0px 4px 0px #15c7a7;
    }
    &:focus {
      border-color: #15c7a7;
    }
  }
  .patronymic {
    flex: ${(props) => props.flex || '0 1 calc(50% - 10px)'};
    min-width: 0;
  }
`;

export const ErrorMessage = styled.div`
  color: #e45270;
  font-size: 12px;
  margin-top: 4px;
  font-weight: 500;
  position: relative;
  z-index: 1;

  &.phone-number {
    margin-top: 20px;
  }
`;
